import * as Yup from 'yup';
import { TRAVEL_MAX_AGE, TRAVEL_MAX_DAYS, TRAVEL_MIN_AGE, TRAVEL_MIN_DAYS } from '../constants/travelCalcConstants';
import { getStartDate } from '../helpers/dates';

export const payloadSchema = Yup.object({
  travelers: Yup.array().of(
    Yup.object().shape({
      age: Yup.number()
        .nullable()
        .min(TRAVEL_MIN_AGE, 'validationErrors.travelAge')
        .max(TRAVEL_MAX_AGE, 'validationErrors.travelAge')
        .required('validationErrors.isRequired'),
      socCard: Yup.string().nullable(),
      passport: Yup.string().nullable(),
    }),
  ),
  region: Yup.string().nullable().required('validationErrors.isRequired'),
  days: Yup.number()
    .max(TRAVEL_MAX_DAYS, 'validationErrors.maxDays')
    .typeError('validationErrors.isRequired')
    .required('validationErrors.isRequired')
    .test('min-travel-days', 'validationErrors.minDays', function (days) {
      if (this.parent.hasOnlyLiteDisallowedCountry && days >= 0) {
        return true;
      } return !(this.parent.hasOnlyLiteDisallowedCountry === false && days < TRAVEL_MIN_DAYS);
    }),
  quoteRequests: Yup.array().of(
    Yup.object({
      package: Yup.string(),
      amount: Yup.number(),
      currency: Yup.string(),
      coverages: Yup.array().of(
        Yup.object().shape({
          id: Yup.string(),
          active: Yup.bool(),
        }),
      ),
    }),
  ),
});

export const calculatorSchema = payloadSchema.shape({
  age: Yup.number()
    .nullable()
    .min(TRAVEL_MIN_AGE, 'validationErrors.travelAge')
    .max(TRAVEL_MAX_AGE, 'validationErrors.travelAge')
    .required('validationErrors.isRequired'),
  start: Yup.date()
    .typeError('validationErrors.invalidDate')
    .nullable()
    .min(new Date(getStartDate().setDate(getStartDate().getDate())), 'validationErrors.travelStartDateMessage')
    .required('validationErrors.isRequired'),
  end: Yup.date()
    .nullable()
    .min(Yup.ref('start'), 'validationErrors.travelEndDateMessage')
    .required('validationErrors.isRequired')
    .typeError('validationErrors.invalidDate')
    .test('min-after-start', 'validationErrors.travelEndDateMessage', function (endDate) {
      if (endDate && this.parent.start) {
        const startDate = this.parent.start;
        const minDate = new Date(startDate);
        minDate.setDate(startDate.getDate() + this.parent.defaultMinDays - 1);
        return endDate >= minDate;
      }
      return !endDate && !this.parent.start;
    }),
});

export const contractCalculatorSchema = calculatorSchema.shape({
  age: Yup.number().notRequired(),
  hasAgreed: Yup.boolean().oneOf([true]),
});
